<div id="dashboard-analytics" class="page-layout blank">
    <div class="content">

        <div class="left mr-lg-32">

            <div class="pb-24 font-size-18 font-weight-300">
                {{'Error receipts error'|translate}}
                <app-info message="Report show error messages returned by fiscal printer."></app-info>
            </div>

            <div fxLayout="column" fxLayoutAlign="start"
                 fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <div class="widget pt-0" fxFlex="100">
                    <div class="fuse-card content-card auto-width">
                        <table class="simple clickable">
                            <thead>
                            <tr>
                                <th>{{'Date'|translate}}</th>
                                <th>{{'UUID'|translate}}</th>
                                <th class="text-center">{{'Total'|translate}}</th>
                                <th class="text-center">{{'Error code'|translate}}</th>
                                <th>{{'Payment method'|translate}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let row of reportData">
                                <td>{{row.printedAt|date: 'dd.MM.y HH:mm:ss': 'UTC+2': 'pl'}}</td>
                                <td>{{row.uuid}}</td>
                                <td class="text-center">{{row.Total}}</td>
                                <td class="text-center">{{row.errorCode}}</td>
                                <td class="text-left">{{row.PaymentMethod}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
